// eslint-disable-next-line @typescript-eslint/no-var-requires
const slugify = require('./slugify');

export interface BreadcrumbItem {
  label: string;
  url?: string;
}

/**
 * Build breadcrumb nav items for phone catalogue PDP.
 * Home → Category (optional) → Brand (optional) → Product name
 */
export const buildPhoneBreadcrumbItems = ({
  categoryLabel,
  brand,
  title,
  host = process.env.GATSBY_HOST || '',
}: {
  categoryLabel: string;
  brand: string;
  title: string;
  host?: string;
}): BreadcrumbItem[] => {
  const categorySlug = slugify(categoryLabel) || '';
  const brandSlug = slugify(brand) || '';
  return [
    { label: 'Home', url: `${host}/` },
    ...(categoryLabel
      ? [{ label: categoryLabel, url: `${host}/?category=${categorySlug}` }]
      : []),
    ...(brand
      ? [
          {
            label: brand,
            url: categoryLabel
              ? `${host}/?category=${categorySlug}&brand=${brandSlug}`
              : `${host}/?brand=${brandSlug}`,
          },
        ]
      : []),
    { label: title },
  ];
};

/**
 * Build breadcrumb nav items for RRP accessories PDP.
 * Home → Devices & gadgets → Category (optional) → Brand (optional) → Product name
 */
export const buildRrpBreadcrumbItems = ({
  cataloguePath,
  categoryLabel,
  brand,
  title,
  host = process.env.GATSBY_HOST || '',
}: {
  cataloguePath: string;
  categoryLabel: string;
  brand: string;
  title: string;
  host?: string;
}): BreadcrumbItem[] => {
  const categorySlug = slugify(categoryLabel) || '';
  const brandSlug = slugify(brand) || '';
  return [
    { label: 'Home', url: `${host}/` },
    { label: 'Devices & gadgets', url: `${host}${cataloguePath}` },
    ...(categoryLabel
      ? [{ label: categoryLabel, url: `${host}${cataloguePath}?category=${categorySlug}` }]
      : []),
    ...(brand
      ? [
          {
            label: brand,
            url: categoryLabel
              ? `${host}${cataloguePath}?category=${categorySlug}&brand=${brandSlug}`
              : `${host}${cataloguePath}?brand=${brandSlug}`,
          },
        ]
      : []),
    { label: title },
  ];
};

/**
 * Derive a BreadcrumbList JSON-LD schema from a breadcrumb items array.
 * Note: @context is intentionally omitted — the SEO component adds it when
 * combining schemas into a single @graph script tag.
 */
export const buildBreadcrumbSchema = (items: BreadcrumbItem[]) => ({
  '@type': 'BreadcrumbList',
  itemListElement: items.map(({ label, url }, index) => ({
    '@type': 'ListItem',
    position: index + 1,
    name: label,
    ...(url ? { item: url } : {}),
  })),
});
